// foundation.ts
export const foundationTokens = {
  "color": {
    "neutral": {
      "50": {
        "value": "#e1e1e1",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#e1e1e1",
          "type": "color"
        },
        "name": "ColorNeutral50",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "50"
        },
        "path": [
          "color",
          "neutral",
          "50"
        ]
      },
      "100": {
        "value": "#d2d2d2",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#d2d2d2",
          "type": "color"
        },
        "name": "ColorNeutral100",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "100"
        },
        "path": [
          "color",
          "neutral",
          "100"
        ]
      },
      "200": {
        "value": "#b5b5b5",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#b5b5b5",
          "type": "color"
        },
        "name": "ColorNeutral200",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "200"
        },
        "path": [
          "color",
          "neutral",
          "200"
        ]
      },
      "300": {
        "value": "#979797",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#979797",
          "type": "color"
        },
        "name": "ColorNeutral300",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "300"
        },
        "path": [
          "color",
          "neutral",
          "300"
        ]
      },
      "400": {
        "value": "#7a7a7a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#7a7a7a",
          "type": "color"
        },
        "name": "ColorNeutral400",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "400"
        },
        "path": [
          "color",
          "neutral",
          "400"
        ]
      },
      "500": {
        "value": "#5c5c5c",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#5c5c5c",
          "type": "color"
        },
        "name": "ColorNeutral500",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "500"
        },
        "path": [
          "color",
          "neutral",
          "500"
        ]
      },
      "600": {
        "value": "#4a4a4a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#4a4a4a",
          "type": "color"
        },
        "name": "ColorNeutral600",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "600"
        },
        "path": [
          "color",
          "neutral",
          "600"
        ]
      },
      "700": {
        "value": "#373737",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#373737",
          "type": "color"
        },
        "name": "ColorNeutral700",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "700"
        },
        "path": [
          "color",
          "neutral",
          "700"
        ]
      },
      "800": {
        "value": "#252525",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#252525",
          "type": "color"
        },
        "name": "ColorNeutral800",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "800"
        },
        "path": [
          "color",
          "neutral",
          "800"
        ]
      },
      "900": {
        "value": "#121212",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#121212",
          "type": "color"
        },
        "name": "ColorNeutral900",
        "attributes": {
          "category": "color",
          "type": "neutral",
          "item": "900"
        },
        "path": [
          "color",
          "neutral",
          "900"
        ]
      }
    },
    "primary": {
      "50": {
        "value": "#fff3e8",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFF3E8",
          "type": "color"
        },
        "name": "ColorPrimary50",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "50"
        },
        "path": [
          "color",
          "primary",
          "50"
        ]
      },
      "100": {
        "value": "#ffdcc2",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFDCC2",
          "type": "color"
        },
        "name": "ColorPrimary100",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "100"
        },
        "path": [
          "color",
          "primary",
          "100"
        ]
      },
      "200": {
        "value": "#ffb980",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFB980",
          "type": "color"
        },
        "name": "ColorPrimary200",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "200"
        },
        "path": [
          "color",
          "primary",
          "200"
        ]
      },
      "300": {
        "value": "#ff9952",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FF9952",
          "type": "color"
        },
        "name": "ColorPrimary300",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "300"
        },
        "path": [
          "color",
          "primary",
          "300"
        ]
      },
      "400": {
        "value": "#ff7f26",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FF7F26",
          "type": "color"
        },
        "name": "ColorPrimary400",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "400"
        },
        "path": [
          "color",
          "primary",
          "400"
        ]
      },
      "500": {
        "value": "#ff6801",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FF6801",
          "type": "color"
        },
        "name": "ColorPrimary500",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "500"
        },
        "path": [
          "color",
          "primary",
          "500"
        ]
      },
      "600": {
        "value": "#d95900",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#D95900",
          "type": "color"
        },
        "name": "ColorPrimary600",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "600"
        },
        "path": [
          "color",
          "primary",
          "600"
        ]
      },
      "700": {
        "value": "#a84800",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#A84800",
          "type": "color"
        },
        "name": "ColorPrimary700",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "700"
        },
        "path": [
          "color",
          "primary",
          "700"
        ]
      },
      "800": {
        "value": "#703000",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#703000",
          "type": "color"
        },
        "name": "ColorPrimary800",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "800"
        },
        "path": [
          "color",
          "primary",
          "800"
        ]
      },
      "900": {
        "value": "#3c1800",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#3C1800",
          "type": "color"
        },
        "name": "ColorPrimary900",
        "attributes": {
          "category": "color",
          "type": "primary",
          "item": "900"
        },
        "path": [
          "color",
          "primary",
          "900"
        ]
      }
    },
    "success": {
      "50": {
        "value": "#e9f9f1",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#E9F9F1",
          "type": "color"
        },
        "name": "ColorSuccess50",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "50"
        },
        "path": [
          "color",
          "success",
          "50"
        ]
      },
      "100": {
        "value": "#c5f0dc",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#C5F0DC",
          "type": "color"
        },
        "name": "ColorSuccess100",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "100"
        },
        "path": [
          "color",
          "success",
          "100"
        ]
      },
      "200": {
        "value": "#8dddbb",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#8DDDBB",
          "type": "color"
        },
        "name": "ColorSuccess200",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "200"
        },
        "path": [
          "color",
          "success",
          "200"
        ]
      },
      "300": {
        "value": "#57c996",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#57C996",
          "type": "color"
        },
        "name": "ColorSuccess300",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "300"
        },
        "path": [
          "color",
          "success",
          "300"
        ]
      },
      "400": {
        "value": "#35b67d",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#35B67D",
          "type": "color"
        },
        "name": "ColorSuccess400",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "400"
        },
        "path": [
          "color",
          "success",
          "400"
        ]
      },
      "500": {
        "value": "#0fa15f",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#0FA15F",
          "type": "color"
        },
        "name": "ColorSuccess500",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "500"
        },
        "path": [
          "color",
          "success",
          "500"
        ]
      },
      "600": {
        "value": "#0d8c53",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#0D8C53",
          "type": "color"
        },
        "name": "ColorSuccess600",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "600"
        },
        "path": [
          "color",
          "success",
          "600"
        ]
      },
      "700": {
        "value": "#0b7245",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#0B7245",
          "type": "color"
        },
        "name": "ColorSuccess700",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "700"
        },
        "path": [
          "color",
          "success",
          "700"
        ]
      },
      "800": {
        "value": "#095b39",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#095B39",
          "type": "color"
        },
        "name": "ColorSuccess800",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "800"
        },
        "path": [
          "color",
          "success",
          "800"
        ]
      },
      "900": {
        "value": "#073f2a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#073F2A",
          "type": "color"
        },
        "name": "ColorSuccess900",
        "attributes": {
          "category": "color",
          "type": "success",
          "item": "900"
        },
        "path": [
          "color",
          "success",
          "900"
        ]
      }
    },
    "warning": {
      "50": {
        "value": "#fff9e5",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFF9E5",
          "type": "color"
        },
        "name": "ColorWarning50",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "50"
        },
        "path": [
          "color",
          "warning",
          "50"
        ]
      },
      "100": {
        "value": "#fff2bf",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFF2BF",
          "type": "color"
        },
        "name": "ColorWarning100",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "100"
        },
        "path": [
          "color",
          "warning",
          "100"
        ]
      },
      "200": {
        "value": "#ffe68a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFE68A",
          "type": "color"
        },
        "name": "ColorWarning200",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "200"
        },
        "path": [
          "color",
          "warning",
          "200"
        ]
      },
      "300": {
        "value": "#ffd34d",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFD34D",
          "type": "color"
        },
        "name": "ColorWarning300",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "300"
        },
        "path": [
          "color",
          "warning",
          "300"
        ]
      },
      "400": {
        "value": "#ffc31f",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFC31F",
          "type": "color"
        },
        "name": "ColorWarning400",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "400"
        },
        "path": [
          "color",
          "warning",
          "400"
        ]
      },
      "500": {
        "value": "#ffb300",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FFB300",
          "type": "color"
        },
        "name": "ColorWarning500",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "500"
        },
        "path": [
          "color",
          "warning",
          "500"
        ]
      },
      "600": {
        "value": "#e69e00",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#E69E00",
          "type": "color"
        },
        "name": "ColorWarning600",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "600"
        },
        "path": [
          "color",
          "warning",
          "600"
        ]
      },
      "700": {
        "value": "#b87900",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#B87900",
          "type": "color"
        },
        "name": "ColorWarning700",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "700"
        },
        "path": [
          "color",
          "warning",
          "700"
        ]
      },
      "800": {
        "value": "#805400",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#805400",
          "type": "color"
        },
        "name": "ColorWarning800",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "800"
        },
        "path": [
          "color",
          "warning",
          "800"
        ]
      },
      "900": {
        "value": "#4c3100",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#4C3100",
          "type": "color"
        },
        "name": "ColorWarning900",
        "attributes": {
          "category": "color",
          "type": "warning",
          "item": "900"
        },
        "path": [
          "color",
          "warning",
          "900"
        ]
      }
    },
    "error": {
      "50": {
        "value": "#fceaea",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#FCEAEA",
          "type": "color"
        },
        "name": "ColorError50",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "50"
        },
        "path": [
          "color",
          "error",
          "50"
        ]
      },
      "100": {
        "value": "#f7c6c6",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#F7C6C6",
          "type": "color"
        },
        "name": "ColorError100",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "100"
        },
        "path": [
          "color",
          "error",
          "100"
        ]
      },
      "200": {
        "value": "#ee9a9a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#EE9A9A",
          "type": "color"
        },
        "name": "ColorError200",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "200"
        },
        "path": [
          "color",
          "error",
          "200"
        ]
      },
      "300": {
        "value": "#e36c6c",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#E36C6C",
          "type": "color"
        },
        "name": "ColorError300",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "300"
        },
        "path": [
          "color",
          "error",
          "300"
        ]
      },
      "400": {
        "value": "#d94a4a",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#D94A4A",
          "type": "color"
        },
        "name": "ColorError400",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "400"
        },
        "path": [
          "color",
          "error",
          "400"
        ]
      },
      "500": {
        "value": "#cc2929",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#CC2929",
          "type": "color"
        },
        "name": "ColorError500",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "500"
        },
        "path": [
          "color",
          "error",
          "500"
        ]
      },
      "600": {
        "value": "#b02424",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#B02424",
          "type": "color"
        },
        "name": "ColorError600",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "600"
        },
        "path": [
          "color",
          "error",
          "600"
        ]
      },
      "700": {
        "value": "#8c1e1e",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#8C1E1E",
          "type": "color"
        },
        "name": "ColorError700",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "700"
        },
        "path": [
          "color",
          "error",
          "700"
        ]
      },
      "800": {
        "value": "#661616",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#661616",
          "type": "color"
        },
        "name": "ColorError800",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "800"
        },
        "path": [
          "color",
          "error",
          "800"
        ]
      },
      "900": {
        "value": "#3d0e0e",
        "type": "color",
        "filePath": "design-tokens/Foundations.json",
        "isSource": true,
        "original": {
          "value": "#3D0E0E",
          "type": "color"
        },
        "name": "ColorError900",
        "attributes": {
          "category": "color",
          "type": "error",
          "item": "900"
        },
        "path": [
          "color",
          "error",
          "900"
        ]
      }
    }
  }
} as const;

export type FoundationTokens = typeof foundationTokens;
